export enum DrugPerscriptionType {
  MEDICINE = "medicine",
  GALENICAL = "galenical",
  HOMEOPATHIC = "homeopathic",
  MEDICINE_FROM_ABROAD = "medicine-from-abroad"
}

export enum DerogationType {
  OTHER_MOTIVATION = "other-motivation", // Altra motivazione
  NO_DEROGATION = "no-derogation", // Nessuna deroga
  SPECIES = "species", // Deroga per specie
  PATHOLOGY = "pathology", // Deroga per patologia
  SPECIES_AND_PATHOLOGY = "species-and-pathology" // Deroga per specie e patologia
}

export enum AntimicrobicMotivationType {
  NO_ALTERNATIVE = "no-alternative", // NOALTERNATIVE
  ON_ANALYTICAL_RESPONSES = "on-analytical-responses", // RISCANALITIC
  ON_EPIDEMIOLOGICAL_LITERATURE = "on-epidemiological-literature", // CONEPIDEMIOLOGICHE
  OTHER = "other" // OTHER
}

export enum MedicineType {
  VACCINE = "vaccine",
  HORMONAL = "hormonal",
  OTHER = "other"
}

export enum StabulogenicMotivationCode {
  NO_AIC = "no-aic",
  IMM_SPECIFICI = "imm-specifici",
  DIFF_INFETTIVE = "diff-infettive"
}

export enum ProphylaxisMetaphylaxisCodeType {
  PROPHYLAXIS = "prophylaxis", // PROFILASSI
  METAPHYLAXIS = "metaphylaxis", // METAFILASSI
  THERAPY = "therapy" // TERAPIA
}

export interface DrugPrescription {
  id: string;
  drugId?: string;
  formularyId?: string;
  name?: string;
  type: DrugPerscriptionType;
  medicineType?: MedicineType;
  aic?: string;
  quantity: number;
  dosage: string;
  chronicalDesease?: boolean;
  treatmentDuration: number;
  repeatability: boolean;
  derogation: DerogationType;
  stabulogenicMotivation?: StabulogenicMotivationCode;
  antimicrobic?: boolean;
  antimicrobicMotivation?: AntimicrobicMotivationType;
  antimicrobicNote?: string;
  prophylaxisMetaphylaxisCode?: ProphylaxisMetaphylaxisCodeType;
  description?: string;
  note?: string;

  prescriptionId?: string;

  addedAt: Date;
  updatedAt?: Date;

  bookItemId?: string;
}

export interface DrugPrescriptionCreate {
  name?: string;
  drugId?: string;
  formularyId?: string;
  type: DrugPerscriptionType;
  aic: string;
  quantity?: number;
  medicineType: MedicineType;
  dosage?: string;
  treatmentDuration?: number;
  chronicalDesease?: boolean;
  repeatability?: boolean;
  description?: string;
  note?: string;
  prophylaxisMetaphylaxisCode?: ProphylaxisMetaphylaxisCodeType;
  antimicrobic?: boolean;
  antimicrobicMotivation?: AntimicrobicMotivationType;
  antimicrobicNote?: string;
  stabulogenicMotivation?: StabulogenicMotivationCode;
  derogation: DerogationType;
}
